import React, { Fragment, useContext, useMemo, useState, useEffect } from "react";
import { getTransactionList, deleteTransaction, getAccountList, getCategoryList } from "../Apis/apis";
import moment from "moment/moment";
import DateView from "./DateView";
import AddDailog from "./AddDailog";
import AccountDialog from "./AccountDialog";
import AllStateContext from "../../context/allstateContext";
import DateDialog from "../../Common/DateDialog";
import TimeDialog from "../../Common/TimeDialog";
import MothFilterDialog from "../../Common/MothFilterDialog";
import { API_RESP_STATUS } from "../../Constant/constant";
import DeletedConfirmationDialog from "../../Common/DeletedConfirmationDialog";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import MailStatementDialog from "../../Common/MailStatementDialog";

export const Record = () => {
  const history = useNavigate();

  // const [data, setData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  // const [startEndDate, setStartEndDate] = useState({});
  const {
    openTimeDialog,
    setOpen,
    openDateDialog,
    openAccount,
    setRecordItem,
    startEndDate,
    setStartEndDate,
    searchDetail,
    openMonthFilterDialog,
  } = useContext(AllStateContext);
  const [selectedOption, setSelectedOption] = useState("both");
  const [openMailDialog, setOpenMailDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const { openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog } =
    useContext(AllStateContext);

  const [showAdvFilters, setShowAdvFilters] = useState(false);
  const [advFilters, setAdvFilters] = useState({ categoryId: "", accountId: "", minAmount: "", maxAmount: "" });
  const [accountList, setAccountList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    getAccountList().then(res => setAccountList(res.data?.payload?.data || []));
    getCategoryList().then(res => setCategoryList(res.data?.payload?.data || []));
  }, []);

  const handleSelectionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const { data, error, isLoading, refetch } = useQuery(
    ["recordListApiCall", startEndDate, searchDetail, selectedOption, advFilters],
    async () => {
      const showAll = true;
      let search = { notes: searchDetail.name };
      if (selectedOption === "expense") {
        search["type"] = 1;
      } else if (selectedOption === "income") {
        search["type"] = 2;
      }
      if (advFilters.categoryId) search["categoryId"] = advFilters.categoryId;
      if (advFilters.accountId) search["accountId"] = advFilters.accountId;
      if (advFilters.minAmount) search["minAmount"] = advFilters.minAmount;
      if (advFilters.maxAmount) search["maxAmount"] = advFilters.maxAmount;
      const response = await getTransactionList(
        search,
        startEndDate.startDate,
        startEndDate.endDate,
        showAll
      );
      setGroupData(
        response.data?.payload?.data?.reduce((acc, item) => {
          const date = new Date(item.date).toLocaleDateString("en-IN");
          acc[date] = acc[date] || {
            items: [],
            sumDebit: 0,
            sumCredit: 0,
          };
          acc[date].items.push(item);

          if (item.type === 1) {
            acc[date].sumDebit += item.amount;
          } else if (item.type === 2) {
            acc[date].sumCredit += item.amount;
          }

          return acc;
        }, {})
      );
      return response.data;
    },
    { keepPreviousData: true }
  );
  if (error) {
    if (error.response.status == API_RESP_STATUS.unauthorized) {
      localStorage.removeItem("token");
      history("/login");
    }
  }

  const itemClick = (item) => {
    setOpen(true);
    setRecordItem(item);
  };

  const handleDeleteConfirm = async () => {
    if (!deleteItemId) return;
    try {
      await deleteTransaction(deleteItemId);
      refetch();
    } catch (err) {
      console.error("Delete failed:", err);
    }
    setDeleteItemId(null);
  };

  function ListItem({ item }) {

    return (
      <div 
        className="list-group-item d-flex align-items-center justify-content-between"
        style={{
          borderBottom: "1px solid var(--border-color)",
          padding: "16px 20px !important"
        }}
      >
        <div className="d-flex align-items-center gap-3">
          <div 
            style={{ 
              width: "48px", 
              height: "48px", 
              borderRadius: "12px", 
              background: "var(--bg-surface-hover)", 
              border: "1px solid var(--border-color)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img
              style={{ height: "32px", width: "32px", borderRadius: "6px" }}
              src={item?.categoryDetails?.iconDetail?.icon}
              alt={item?.categoryDetails?.name}
            />
          </div>
          <div>
            <div style={{ fontSize: "1rem", fontWeight: "600", color: "var(--text-primary)" }}>
              {item?.categoryDetails?.name}
            </div>
            <div className="d-flex align-items-center gap-2 mt-1">
              <div className="d-flex align-items-center gap-1">
                <img
                  style={{ height: "16px", width: "16px" }}
                  src={item?.accountDetails?.iconDetail?.icon}
                  alt={item?.accountDetails?.iconDetail?.name}
                />
                <span style={{ fontSize: "0.82rem", color: "var(--text-secondary)" }}>
                  {item?.accountDetails?.name}
                </span>
              </div>
              {item?.notes && (
                <>
                  <span style={{ color: "var(--text-muted)", fontSize: "0.8rem" }}>•</span>
                  <span style={{ fontSize: "0.82rem", color: "var(--text-muted)" }}>
                    {item?.notes}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center gap-3">
          <div 
            style={{
              fontSize: "1.1rem",
              fontWeight: "700",
              color: item?.type === 1 ? "var(--danger)" : "var(--success)",
              marginRight: "10px"
            }}
          >
            {item?.type === 1 ? `-₹${item.amount.toLocaleString("en-IN")}` : `+₹${item.amount.toLocaleString("en-IN")}`}
          </div>
          
          <div className="d-flex align-items-center gap-1 action-buttons">
            <button
              onClick={() => itemClick(item)}
              className="btn btn-secondary"
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                padding: "0",
                minWidth: "32px",
                background: "var(--bg-surface-hover)",
                borderColor: "var(--border-color)"
              }}
            >
              <img
                style={{ width: "14px", height: "14px", filter: "invert(1)" }}
                src={require("../../Common/Icon/edit.png")}
                alt="edit-transaction"
              />
            </button>
            <button
              onClick={() => {
                setDeleteItemId(item.transactionId);
                setOpenDeleteConfirmationDialog(true);
              }}
              className="btn btn-secondary"
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                padding: "0",
                minWidth: "32px",
                background: "rgba(239, 68, 68, 0.05)",
                borderColor: "rgba(239, 68, 68, 0.1)"
              }}
            >
              <img
                style={{ width: "14px", height: "14px", filter: "invert(1)" }}
                src={require("../../Common/Icon/delete_icon.png")}
                alt="delete-transaction"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingBottom: "40px" }}>
      <div>
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <DateView
              totalExpense={data?.payload?.totalInEx?.totalExpense}
              totalIncome={data?.payload?.totalInEx?.totalIncome}
            />
            <AddDailog fetchData={refetch} />

            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
              <h5 style={{ fontWeight: "700", margin: "0", letterSpacing: "0.02em" }}>
                Transactions
              </h5>
              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-primary shadow-sm"
                  style={{
                    padding: "6px 14px",
                    fontSize: "0.9rem",
                    fontWeight: "700",
                    borderRadius: "10px",
                    letterSpacing: "0.02em"
                  }}
                  onClick={() => setOpenMailDialog(true)}
                >
                  ✉ Mail Statement
                </button>
                <button
                  className={`btn ${showAdvFilters ? 'btn-primary' : 'btn-outline-primary'}`}
                  style={{
                    padding: "6px 14px",
                    fontSize: "0.9rem",
                    fontWeight: "700",
                    borderRadius: "10px",
                    letterSpacing: "0.02em"
                  }}
                  onClick={() => setShowAdvFilters(!showAdvFilters)}
                >
                  ⚙ Filters
                </button>
                <select
                  value={selectedOption}
                  onChange={handleSelectionChange}
                  className="form-select"
                  style={{
                    width: "180px",
                    fontSize: "0.9rem",
                    padding: "6px 36px 6px 12px",
                    backgroundPosition: "right 12px center",
                    borderRadius: "10px",
                    borderColor: "var(--border-color)",
                    backgroundColor: "var(--bg-surface)",
                    color: "var(--text-primary)"
                  }}
                >
                  <option value="both">All Transactions</option>
                  <option value="income">Income Only</option>
                  <option value="expense">Expense Only</option>
                </select>
              </div>
            </div>

            {/* Advanced Filters Panel */}
            {showAdvFilters && (
              <div className="glass-card mb-4" style={{ padding: "20px" }}>
                <div className="row g-3">
                  <div className="col-12 col-md-3">
                    <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: "600" }}>Category</label>
                    <select 
                      className="form-select" 
                      value={advFilters.categoryId}
                      onChange={(e) => setAdvFilters({ ...advFilters, categoryId: e.target.value })}
                      style={{ fontSize: "0.9rem" }}
                    >
                      <option value="">All Categories</option>
                      {categoryList.map(cat => (
                        <option key={cat.categoryId} value={cat.categoryId}>{cat.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: "600" }}>Account</label>
                    <select 
                      className="form-select" 
                      value={advFilters.accountId}
                      onChange={(e) => setAdvFilters({ ...advFilters, accountId: e.target.value })}
                      style={{ fontSize: "0.9rem" }}
                    >
                      <option value="">All Accounts</option>
                      {accountList.map(acc => (
                        <option key={acc.accountId} value={acc.accountId}>{acc.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-2">
                    <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: "600" }}>Min Amount</label>
                    <input 
                      type="number" 
                      className="form-control" 
                      placeholder="0"
                      value={advFilters.minAmount}
                      onChange={(e) => setAdvFilters({ ...advFilters, minAmount: e.target.value })}
                      style={{ fontSize: "0.9rem" }}
                    />
                  </div>
                  <div className="col-12 col-md-2">
                    <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: "600" }}>Max Amount</label>
                    <input 
                      type="number" 
                      className="form-control" 
                      placeholder="Any"
                      value={advFilters.maxAmount}
                      onChange={(e) => setAdvFilters({ ...advFilters, maxAmount: e.target.value })}
                      style={{ fontSize: "0.9rem" }}
                    />
                  </div>
                  <div className="col-12 col-md-2 d-flex align-items-end">
                    <button 
                      className="btn btn-outline-secondary w-100"
                      onClick={() => setAdvFilters({ categoryId: "", accountId: "", minAmount: "", maxAmount: "" })}
                      style={{ fontSize: "0.9rem", fontWeight: "600", padding: "8px" }}
                    >
                      Clear Filters
                    </button>
                  </div>
                </div>
              </div>
            )}

            <MailStatementDialog 
              open={openMailDialog} 
              onClose={() => setOpenMailDialog(false)} 
              isRecordTab={true}
              filter={searchDetail}
              startDate={startEndDate?.startDate}
              endDate={startEndDate?.endDate}
            />

            {openAccount && <AccountDialog />}
            {openDateDialog && <DateDialog />}
            {openTimeDialog && <TimeDialog />}
            {openDeleteConfirmationDialog && (
              <DeletedConfirmationDialog isDeleted={handleDeleteConfirm} />
            )}

            <div>
              {groupData && Object.keys(groupData).length > 0 ? (
                Object.entries(groupData)?.map(
                  ([date, { items, sumDebit, sumCredit }]) => (
                    <div className="list-group mb-4" key={date} style={{ border: "1px solid var(--border-color)", borderRadius: "16px", overflow: "hidden", boxShadow: "var(--glass-shadow)" }}>
                      <div 
                        className="list-group-item list-group-item-header d-flex flex-wrap align-items-center justify-content-between gap-2"
                        style={{
                          background: "var(--bg-surface) !important",
                          borderBottom: "1px solid var(--border-color) !important",
                          padding: "14px 20px !important"
                        }}
                      >
                        <div style={{ fontWeight: "700", color: "var(--text-primary)", fontSize: "0.95rem" }}>
                          {moment(date, "D/M/YYYY").format("MMM D, dddd")}
                        </div>
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          {sumCredit > 0 && (
                            <span className="badge-income">
                              IN: +₹{sumCredit.toLocaleString("en-IN")}
                            </span>
                          )}
                          {sumDebit > 0 && (
                            <span className="badge-expense">
                              OUT: -₹{sumDebit.toLocaleString("en-IN")}
                            </span>
                          )}
                          <span className="badge-balance">
                            BAL: ₹{(sumCredit - sumDebit).toLocaleString("en-IN")}
                          </span>
                        </div>
                      </div>
                      
                      {items?.map((item) => (
                        <ListItem
                          key={item?.transactionId}
                          item={item}
                        />
                      ))}
                    </div>
                  )
                )
              ) : (
                <div className="text-center py-5 glass-card">
                  <div style={{ fontSize: "1.2rem", fontWeight: "600", color: "var(--text-secondary)" }}>
                    No transactions found for this period
                  </div>
                  <p className="text-muted mt-2 mb-0" style={{ fontSize: "0.9rem" }}>
                    Try changing your filters or add a new transaction using the '+' button.
                  </p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
